import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';

interface IBrandProps {}
const Brand: FC<IBrandProps> = () => {
	return (
		<div className='brand'>
			<div className='brand-logo'>
				<h1 className='brand-title'>
					<Link to='/' aria-label='Logo'>
						<Logo height={70} width={85} />
					</Link>
				</h1>
			</div>
		</div>
	);
};
Brand.propTypes = {};

export default Brand;
